



































































import { Component, Vue, Prop } from "vue-property-decorator";
import { DeleteExams$ } from "@/request/jxgl";
@Component({})
export default class SzksExamList extends Vue {
  @Prop()
  private exams;
  @Prop()
  private filters;
  /**
   * @description 查看
   */
  private check(row) {
    this.$router.push({
      path: "/main/szjx/szks-result",
      query: {
        id: row["exam_id"],
      },
    });
  }
}
